import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";

import { LOADING } from "../../store/actions";
import instance from "../../store/axios";
import PortfolioAgreement from "src/models/portfolio-agreement.model";

class PortfolioAgreementService {
  private dispatch = useDispatch();

  public async getPortfolioAgreementListData(
    page,
    searchWord,
    sortField,
    sortOrder,
    filters,
    typeFilters
  ): Promise<any> {
    this.dispatch({ type: LOADING, payload: true });
    let query: string = `?page=${page}&pageSize=20`;

    if (searchWord) {
      query += `&search=${searchWord}`;
    }

    if (sortField) {
      query += `&sortField=${sortField}`;
    }

    if (sortOrder) {
      query += `&sortOrder=${sortOrder === "ascend" ? "asc" : "desc"}`;
    }

    if (filters?.length && filters != "null") {
      filters.forEach((filter) => {
        query += `&status[]=${filter}`;
      });
    }

    if (typeFilters?.length && typeFilters != "null") {
      query += `&type=${typeFilters.join(",")}`;
    }

    try {
      const response: any = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/portfolio/new-portfolio-agreements${query}`
      );
      return response;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/home/portfolio-agreement`);

      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async exportPortfolioAgreementListData(
    page,
    searchWord,
    sortField,
    sortOrder,
    filters,
    pageSize,
    typeFilters
  ): Promise<any> {
    this.dispatch({ type: LOADING, payload: true });
    let query: string = `?page=${page}&pageSize=${pageSize}`;

    if (searchWord) {
      query += `&search=${searchWord}`;
    }

    if (sortField) {
      query += `&sortField=${sortField}`;
    }

    if (sortOrder) {
      query += `&sortOrder=${sortOrder === "ascend" ? "asc" : "desc"}`;
    }

    if (filters?.length && filters != "null") {
      filters.forEach((filter) => {
        query += `&status[]=${filter}`;
      });
    }

    if (typeFilters?.length && typeFilters != "null") {
      query += `&type=${typeFilters.join(",")}`;
    }

    try {
      const response: any = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/portfolio/new-portfolio-agreements${query}`
      );
      return response;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/home/portfolio-agreement`);

      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async regenerateAgreement(agreementId: number, viewOnly: boolean, asOfDate: string): Promise<boolean> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<any> = await instance.post(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/portfolio/regenerate-new-portfolio-agreement/${agreementId}`,
        { agreementId, viewOnly, asOfDate }
      );
      toast.success("Agreement regenerated successfully");
      return response.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "Failed to regenerate agreement");
      }
      localStorage.setItem("star_prev_url", `/home/portfolio-agreement`);

      return false;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }
}

export default PortfolioAgreementService;
